import { useState, useCallback, useMemo } from 'react';
import type { RepairBookingSession, Shop } from '../models/repair-bookings';
import { fetchShops } from '../utils/api';
import { useFetch } from './use-fetch';

const useShops = (session: RepairBookingSession, productId?: number) => {
    const fetcher = useCallback(() => {
        return fetchShops(session.csrfToken, session.sessionId, productId);
    }, [session, productId]);
    const { data, error } = useFetch(fetcher);

    const shopsByPrefectures = useMemo(() => {
        const shops = data?.shops ?? [];
        return shops.reduce<Record<string, Shop[]>>((groupedShops, shop) => {
            const prefectureShops = groupedShops[shop.region] ?? (groupedShops[shop.region] = []);
            prefectureShops.push(shop);
            return groupedShops;
        }, {});
    }, [data]);

    const [selectedShop, setSelectedShop] = useState<Shop | null>(null);
    const [selectedPrefecture, setSelectedPrefecture] = useState<string | null>(null);

    return {
        shopsByPrefectures,
        selectedShop,
        selectedPrefecture,
        error,
        setSelectedShop,
        setSelectedPrefecture,
    };
};

export default useShops;
